import { render } from "./ManufacturingDataBlocks.vue?vue&type=template&id=044cb03f&scoped=true"
import script from "./ManufacturingDataBlocks.vue?vue&type=script&lang=ts"
export * from "./ManufacturingDataBlocks.vue?vue&type=script&lang=ts"

import "./ManufacturingDataBlocks.vue?vue&type=style&index=0&id=044cb03f&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-044cb03f"

export default script